// eslint-disable-next-line no-shadow
enum Local {
  ENG = 'en',
  RU = 'ru',
}

export default Local;
